<template>
  <v-btn
    :disabled="params.disabled || params.data.generated !== params.generatedStatus"
    :title="params.title"
    density="compact"
    icon="mdi-table-edit"
    variant="text"
    @click="params.open(params.data)"
  />
</template>

<script>
export default {};
</script>
